var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNumber02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2703_57344)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0251 28.3334V25.7481L20.0656 20.1551C20.5793 19.6579 21.0102 19.2105 21.3582 18.8128C21.7117 18.415 21.9796 18.0256 22.1619 17.6444C22.3442 17.2578 22.4354 16.8407 22.4354 16.3933C22.4354 15.8961 22.3221 15.468 22.0956 15.1089C21.8692 14.7443 21.5598 14.4654 21.1676 14.272C20.7754 14.0732 20.3307 13.9737 19.8336 13.9737C19.3143 13.9737 18.8613 14.0787 18.4747 14.2886C18.088 14.4985 17.7897 14.7996 17.5798 15.1918C17.3699 15.584 17.2649 16.0508 17.2649 16.5921H13.8594C13.8594 15.4818 14.1107 14.5179 14.6134 13.7003C15.1161 12.8828 15.8204 12.2503 16.7263 11.8028C17.6323 11.3554 18.6763 11.1317 19.8584 11.1317C21.0737 11.1317 22.1315 11.3471 23.032 11.778C23.9379 12.2033 24.6422 12.7944 25.1449 13.5512C25.6476 14.3079 25.8989 15.1752 25.8989 16.153C25.8989 16.7937 25.7719 17.4262 25.5178 18.0505C25.2692 18.6747 24.8245 19.3679 24.1837 20.1302C23.5429 20.887 22.6398 21.7957 21.4742 22.8563L18.9967 25.2841V25.4001H26.1226V28.3334H14.0251Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2703_57344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNumber02);
export default __webpack_public_path__ + "static/media/icon-number-02.8cd7a1ce8d623ed73914408ccbc81665.svg";
export { ForwardRef as ReactComponent };